// extracted by mini-css-extract-plugin
module.exports = {"ContentContainer":"SvgHeader-module--ContentContainer--3RpZi","headerTypist":"SvgHeader-module--headerTypist--uzRiJ"};